import { useStore } from 'react-redux';
import type { IState } from '../../../store/types/State-type';

export function useInvariantSelector<T>(selector: (state: IState) => T): T {
  const state = useStore<IState>().getState();
  return selector(state);
}
